import React from 'react';

import { Button } from '@videoblocks/storywind';

export const NoContentHero = () => {
  return (
    <div className="text-center bg-gray-100 my-14 maker-md:mx-36 mx-4 py-10 maker-md:px-28 px-4 rounded-lg w-auto max-w-fit">
      <img
        className="mb-12"
        src={
          __ASSETS_COMMON_IMAGES_URL__ + '/icons/nothing-found-icon-black.svg'
        }
        alt={'Content Loading Error'}
        loading="eager"
        width={100}
        height={100}
      />
      <p className="pb-10 text-2xl">
        <b>Something went wrong!</b>
      </p>
      <p className="pb-10 text-xl">
        We had an error when trying to load your content. Refresh the page to
        try again.
      </p>
      <Button
        onClick={null}
        href={window.location.href}
        className="text-black no-underline"
      >
        Try Again
      </Button>
    </div>
  );
};

export default NoContentHero;
